export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const popularTabs = {
  popularetab: {
    slide: {
      superandarbahar: {
        redirectUrl: "/casino/aggapevolutiongaming-super-andar-bahar",
        code: "",
        casino: "",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/SuperAndarBahar.jpg",
        alt: "Super Andar Bahar",
        name: "Super Andar Bahar",
        providerName: "ALT Gaming",
      },
      TurkishLightningRoulette: {
        redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
        code: "",
        casino: "",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/turkishlightningroulette.jpg",
        alt: "Turkish Lightning Roulette",
        name: "Turkish Lightning Roulette",
        providerName: "Evolution",
      },
      sweetbonanzacandyand: {
        redirectUrl: "/casino/pp-sweet-bonanza-candyland",
        code: "",
        casino: "",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/SweetBonanzaCandyland.jpg",
        alt: "Sweet Bonanza Candyland",
        name: "Sweet Bonanza Candyland",
        providerName: "Smartsoft",
      },
      TowerRush: {
        redirectUrl: "/casino/glx-tower-rush",
        code: "",
        casino: "Galaxsys",
        provider: "WorldCasino",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/popular/TowerRush.webp",
        alt: "Tower Rush",
        name: "Tower Rush",
        providerName: "WorldCasino",
      },
      jetX: {
        redirectUrl: "/casino/aggapsmartsoftgaming-jetx",
        code: "",
        casino: "",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/Vivo/jetx.webp",
        alt: "jetX",
        name: "jetX",
        providerName: "Smartsoft",
      },
      GalaxyRoulette: {
        redirectUrl: "/casino/vivo-galaxy-roulette",
        code: "",
        casino: "Vivo",
        provider: "Vivo",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/Vivo/GalaxyRoulette.jpg",
        alt: "Galaxy Roulette",
        name: "Galaxy Roulette",
        providerName: "Vivo",
      },
      UltimateAndarBahar: {
        redirectUrl: "/casino/ezg-ultimate-andar-bahar",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/andarbahar/Ultimate-andar-bahar.jpg",
        alt: "ultimate andar bahar",
        name: "Ultimate Andar Bahar",
        providerName: "Ezugi",
      },
      lasvegasroulette: {
        redirectUrl: "/casino/vivo-las-vegas-roulette",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/Vivo/LasVegasRoulette.webp",
        alt: "",
        name: "Las Vegas Roulette",
        providerName: "Vivo",
      },
      XxxtremeLightningRoulette: {
        redirectUrl: "/casino/ezgevo-xxxtreme-lightning-roulette",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/XxxtremeLightningRoulette.jpg",
        alt: "galaxy roulette",
        name: "Galaxy Roulette",
        providerName: "Evolution",
      },
      // GoldBarRoulette: {
      //   redirectUrl: "/casino/ezgevo-gold-bar-roulette",
      //   code: "",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/roulette/GoldBarRoulette.jpg",
      //   alt: "macau baccarat",
      //   name: "Macau Baccarat",
      //   providerName: "Evolution",
      // },
      BlazeRoulette: {
        redirectUrl: "/casino/vivo-oracle-blaze-roulette",
        code: "",
        casino: "Vivo",
        provider: "Vivo",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/Vivo/OracleBlazeRoulette.webp",
        alt: "",
        name: "Blaze Roulette",
        providerName: "Vivo",
      },
      SpeedRoulettePplr: {
        redirectUrl: "/casino/ezugi/SpeedRoulette",
        code: "1000104",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/speed-roulette-evolution.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
      },
      LightningRoulettePplr: {
        redirectUrl: "/casino/ezugi/LightningRoulette",
        code: "1000092",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Lightiningroulette.jpg",
        alt: "",
        name: "Lightning Roulette",
        providerName: "Evolution",
      },
      CasinoMarinaRoulettePplr: {
        redirectUrl: "/casino/ezugi/CasinoMarinaRoulette",
        code: "321000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Casino-Marina-Roulette.jpg",
        alt: "",
        name: "Casino Marina Roulette",
        providerName: "Ezugi",
      },
      BaccaratDance: {
        redirectUrl: "/casino/vivo-baccarat-dance",
        code: "",
        casino: "vivo",
        provider: "vivo",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/Vivo/BaccaratDance.webp",
        alt: "Baccarat Dance",
        name: "Baccarat Dance",
        providerName: "Vivo",
      },
      BaccaratPplr: {
        redirectUrl: "/casino/ezugi/Baccarat",
        code: "100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat08.jpg",
        alt: "",
        name: "Baccarart",
        providerName: "Ezugi",
      },
      SpeedCricketBaccaratPplr: {
        redirectUrl: "/casino/ezugi/SpeedCricketBaccarat",
        code: "101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/Speedcricketbaccarat.jpg",
        alt: "",
        name: "Speed Cricket Baccarat",
        providerName: "Ezugi",
      },
      LightBaccaratPplr: {
        redirectUrl: "/casino/ezugi/LightBaccarat",
        code: "1000149",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/lightning-baccarat.jpg",
        alt: "",
        name: "Lightning Baccarat",
        providerName: "Evolution",
      },
      CaribbeanBaccarat: {
        redirectUrl: "/casino/vivo-caribbean-baccarat",
        code: "",
        casino: "vivo",
        provider: "vivo",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "/images/Vivo/CaribbeanBaccarat.webp",
        alt: "Caribbean Baccarat",
        name: "Caribbean Baccarat",
        providerName: "Vivo",
      },
      BlackjackProPplr: {
        redirectUrl: "/casino/ezugi/BlackjackPro",
        code: "224",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/vip-surrender-blackjack.jpg",
        alt: "",
        name: "VIP Surrender Blackjack",
        providerName: "Ezugi",
      },
      ItalianBlackjackPplr: {
        redirectUrl: "/casino/ezugi/ItalianBlackjack",
        code: "226",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/italian-blackjack.jpg",
        alt: "",
        name: "Italian Blackjack",
        providerName: "Ezugi",
      },
      ClassicSpeedBlackjack1Pplr: {
        redirectUrl: "/casino/ezgevo-classic-speed-blackjack-10",
        code: "1000226",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/Speed-Blackjack-D.jpg",
        alt: "",
        name: " Classic Speed Blackjack 10",
        providerName: "Evolution",
      },
      ImperialDragonTiger: {
        redirectUrl: "/casino/aggapvivogaming-imperial-dragon-tiger",
        code: "",
        casino: "spribe",
        provider: "viov",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/Vivo/ImperialDragonTiger.jpg",
        alt: "",
        name: "Imperial Dragon Tiger",
        providerName: "Vivo",
      },
      BetonTeenPattiPplr: {
        redirectUrl: "/casino/ezugi/BetonTeenPatti",
        code: "227101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/Betonteenpatti.jpg",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      // TeenPatti3cardPplr: {
      //   redirectUrl: "/casino/ezugi/TeenPatti3card",
      //   code: "227100",
      //   casino: "ezugi",
      //   provider: "",
      //   homeUrl: pageUrlGenerator("/Casino"),
      //   imgUrl: "./images/poker/Teenpatti3card.jpg",
      //   alt: "",
      //   name: " Teen Patti 3 Card",
      //   providerName: "Ezugi",
      // },
      UltimatetexasholdemPplr: {
        redirectUrl: "/casino/ezugi/Ultimatetexasholdem",
        code: "1000151",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/ultimatetaxasholden.jpg",
        alt: "",
        name: "Ultimate Texas Holdem",
        providerName: "Evolution",
      },
      CrazyTimePplr: {
        redirectUrl: "/casino/ezugi/CrazyTime",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/CrazyTime.jpg",
        alt: "",
        name: "Crazy Time",
        providerName: "Evolution",
      },
      DreamCatcherPplr: {
        redirectUrl: "/casino/ezugi/DreamCatcher",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/DreamCatcher.jpg",
        alt: "",
        name: "Dream Catcher",
        providerName: "Evolution",
      },
    },
  },
  vimplay: {
    slide: {
      vimplay1: {
        redirectUrl: "/casino/vimplayvimplay-techno-roulette",
        imgUrl: "./images/vimplay/texhnoroulette.jpg",
        name: "TECHNO ROULETTE",
      },
      vimplay2: {
        redirectUrl: "/casino/vimplayvimplay-royal-roulette",
        imgUrl: "./images/vimplay/RoyalRoulette.jpg",
        name: "ROYAL ROULETTE",
      },
      vimplay3: {
        redirectUrl: "/casino/vimplayvimplay-replay-roulette",
        imgUrl: "./images/vimplay/ReplayRoullete.jpg",
        name: "REPLAY ROULETTE",
      },
      vimplay4: {
        redirectUrl: "/casino/vimplayvimplay-cosmic-roulette",
        imgUrl: "./images/vimplay/cosmicroulette.jpg",
        name: "COSMIC ROULETTE",
      },
      vimplay5: {
        redirectUrl: "/casino/vimplayvimplay-rouletto",
        imgUrl: "./images/vimplay/rouletto.jpg",
        name: "ROULETTO",
      },
      vimplay6: {
        redirectUrl: "/casino/vimplayvimplay-bombrunner",
        imgUrl: "./images/vimplay/BombRun.jpg",
        name: "BOMB_RUNNER",
      },
      vimplay7: {
        redirectUrl: "/casino/vimplayvimplay-wishingwell",
        imgUrl: "./images/vimplay/Wishingwell.jpg",
        name: " WISHING_WELL",
      },
      vimplay8: {
        redirectUrl: "/casino/vimplayvimplay-crash-kick",
        imgUrl: "./images/vimplay/crashkick.jpg",
        name: "CRASH KICK",
      },
      vimplay9: {
        redirectUrl: "/casino/vimplayvimplay-lottoluck",
        imgUrl: "./images/vimplay/lottoluck.jpg",
        name: "LOTTO_LUCK",
      },
      vimplay10: {
        redirectUrl: "/casino/vimplayvimplay-dragontap",
        imgUrl: "./images/vimplay/dragontap.jpg",
        name: "DRAGON_TAP",
      },
    },
  },
};
